import React from 'react'

const SvgLungs = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 4h2v6a2 2 0 001.012 1.74C14.36-3.486 22 6.071 22 20.427c-1.116-.366-4.666-1.719-6.64-2.477-.656-.251-1.36-1.278-1.36-1.98v-1.395c-.555-.65-1.277-1.276-2-1.276-.723 0-1.445.627-2 1.276v1.395c0 .702-.703 1.729-1.36 1.98-1.974.758-5.524 2.111-6.64 2.477C2 6.072 9.641-3.485 9.988 11.74A2 2 0 0011 10V4z'
    />
  </svg>
)

export default SvgLungs
